export default {"src":"/_next/static/media/affiliate-label.30a31748.svg","height":82,"width":71,"blurWidth":0,"blurHeight":0};